export default __webpack_public_path__ + "static/media/logo-word-black.6717e63e.png";